<div class="flex flex-row-reverse">
  <mat-slide-toggle
    class="main-toggle"
    (change)="showSelectedOnly.set($event.checked)"
    [checked]="showSelectedOnly()"
    [ngClass]="toggleCssClass()"
    labelPosition="before"
  >
    Show selected
  </mat-slide-toggle>
</div>
<div class="mb-5">
  <app-search-input
    (searchDataEvent)="actionPointSearch.set($event)"
    inputWidth="100%"
    placeholder="Search action points"
  />
</div>
@for (point of filteredActionPoints(); track point.id) {
  @if (formGroups[point.id]) {
    <div
      class="border border-ui-gray-light px-4 py-2 rounded-md mb-2"
      [formGroup]="formGroups[point.id]"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center w-full">
          <mat-checkbox
            class="w-1/4 action-point-checkbox"
            formControlName="checked"
          >
            {{ point.name }}
          </mat-checkbox>
          @if (actionPointEditId() !== point.id) {
            @if (formGroups[point.id].get('valueDataType')?.value) {
              <div class="text-sm text-ui-gray-100 w-1/4">
                Value Type:
                <span class="text-ui-dark">{{ formGroups[point.id].get('valueDataType')?.value }}</span>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'config'])?.value) {
              <div class="text-sm text-ui-gray-100 w-1/4">
                Configure:
                <span class="text-ui-dark">
                  {{ configTitle[formGroups[point.id].get(['valueValidationRule', 'config'])!.value] }}</span>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'values'])?.value) {
              <div class="text-sm text-ui-gray-100 w-1/4">
                Values:
                <span class="text-ui-dark">{{ formGroups[point.id].get(['valueValidationRule', 'values'])!.value }}</span>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'min'])?.value) {
              <div class="text-sm text-ui-gray-100 w-[12.5%]">
                Min:
                <span class="text-ui-dark"> {{ formGroups[point.id].get(['valueValidationRule', 'min'])?.value }}</span>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'max'])?.value) {
              <div class="text-sm text-ui-gray-100 w-[12.5%]">
                Max:
                <span class="text-ui-dark"> {{ formGroups[point.id].get(['valueValidationRule', 'max'])!.value }}</span>
              </div>
            }
          }

        </div>
        <div class="flex items-center justify-between">
          @if (actionPointEditId() === point.id) {
            <button
              class="btn-tiny btn-white-stroked mr-3"
              (click)="$event.preventDefault();cancelEdit(point.id)"
            >Cancel
            </button>
            <button
              class="btn-tiny btn-white-stroked"
              (click)="$event.preventDefault();patchPoint(point.id)"
              [disabled]="formGroups[point.id].invalid"
            >Save
            </button>
          } @else {
            <button
              class="btn-tiny btn-white-stroked mr-3"
              (click)="$event.preventDefault();clear(point)"
            >Clear
            </button>
            <button
              class="btn-tiny btn-white-stroked"
              (click)="$event.preventDefault();startEdit(point.id);"
              [disabled]="actionPointEditId()"
            >Edit
            </button>
          }
        </div>
      </div>

      @if (actionPointEditId() === point.id) {
        <div class="flex">
          <div class="w-1/3 px-2.5">
            <label class="input-main-label block mt-0 mb-1">Value Type *</label>
            <mat-form-field
              class="select-classic has-validation w-full"
              appearance="outline"
            >
              <mat-select
                formControlName="valueDataType"
                panelClass="single-select-overlay"
                placeholder="Choose a value type"
              >
                <mat-option [value]="eActionPointValueDataType.TEXT">Text</mat-option>
                <mat-option [value]="eActionPointValueDataType.BOOLEAN">Boolean</mat-option>
                <mat-option [value]="eActionPointValueDataType.INTEGER">Integer</mat-option>
                <mat-option [value]="eActionPointValueDataType.FLOAT">Float</mat-option>
              </mat-select>
              <mat-icon
                class="arrow-down"
                fontIcon="keyboard_arrow_down"
                matSuffix
              />
              <mat-error>Input is not valid</mat-error>
            </mat-form-field>
          </div>

          <div
            class="w-2/3 flex"
            formGroupName="valueValidationRule"
          >
            @if ((formGroups[point.id].get('valueDataType')?.value === eActionPointValueDataType.INTEGER
              || formGroups[point.id].get('valueDataType')?.value === eActionPointValueDataType.FLOAT)
            && formGroups[point.id].get(['valueValidationRule', 'config'])) {
              <div class="w-1/2 px-2.5">
                <label class="input-main-label block mt-0 mb-1">Configure *</label>
                <mat-form-field
                  class="select-classic has-validation w-full"
                  appearance="outline"
                >
                  <mat-select
                    formControlName="config"
                    panelClass="single-select-overlay"
                    placeholder="Choose configure"
                  >
                    <mat-option [value]="eValueValidationRuleConfig.ENUM">{{ configTitle[eValueValidationRuleConfig.ENUM] }}</mat-option>
                    <mat-option [value]="eValueValidationRuleConfig.MIN_MAX">{{ configTitle[eValueValidationRuleConfig.MIN_MAX] }}</mat-option>
                  </mat-select>
                  <mat-icon
                    class="arrow-down"
                    fontIcon="keyboard_arrow_down"
                    matSuffix
                  />
                  <mat-error>Input is not valid</mat-error>
                </mat-form-field>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'values'])
            && (formGroups[point.id].get('valueDataType')?.value === eActionPointValueDataType.TEXT
              || formGroups[point.id].get(['valueValidationRule', 'config'])?.value === eValueValidationRuleConfig.ENUM)) {
              <div class="w-1/2 px-2.5">
                <label class="input-main-label capitalize block mt-0 mb-1">Values</label>
                <mat-form-field
                  class="input-classic w-full"
                  appearance="outline"
                >
                  <input
                    type="text"
                    formControlName="values"
                    matInput
                    placeholder="Enter value"
                  />
                  <mat-error>Input is not valid</mat-error>
                </mat-form-field>
              </div>
            }

            @if (formGroups[point.id].get('valueDataType')?.value === eActionPointValueDataType.BOOLEAN) {
              <div class="w-1/2 px-2.5">
                <label class="input-main-label block mt-0 mb-1">Values</label>
                <mat-form-field
                  class="select-classic has-validation w-full"
                  appearance="outline"
                >
                  <mat-select
                    formControlName="values"
                    panelClass="single-select-overlay"
                    placeholder="Choose value"
                  >
                    <mat-option value="true">True</mat-option>
                    <mat-option value="false">False</mat-option>
                  </mat-select>
                  <mat-icon
                    class="arrow-down"
                    fontIcon="keyboard_arrow_down"
                    matSuffix
                  />
                  <mat-error>Input is not valid</mat-error>
                </mat-form-field>
              </div>
            }

            @if (formGroups[point.id].get(['valueValidationRule', 'config'])?.value === eValueValidationRuleConfig.MIN_MAX) {
              <div class="flex w-1/2">
                @if (formGroups[point.id].get(['valueValidationRule', 'min'])) {
                  <div class="w-1/2 px-2.5">
                    <label class="input-main-label capitalize block mt-0 mb-1">Min *</label>
                    <mat-form-field
                      class="input-classic w-full"
                      appearance="outline"
                    >
                      <input
                        type="number"
                        formControlName="min"
                        matInput
                        placeholder="0"
                      />
                      <mat-error>Input is not valid</mat-error>
                    </mat-form-field>
                  </div>
                }
                @if (formGroups[point.id].get(['valueValidationRule', 'max'])) {
                  <div class="w-1/2 px-2.5">
                    <label class="input-main-label capitalize block mt-0 mb-1">Max *</label>
                    <mat-form-field
                      class="input-classic w-full"
                      appearance="outline"
                    >
                      <input
                        type="number"
                        formControlName="max"
                        matInput
                        placeholder="10"
                      />
                      <mat-error>Input is not valid</mat-error>
                    </mat-form-field>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        @if (showDCSelect()) {
          <div class="flex items-center justify-between">
            <div class="w-1/3 px-2.5">
              <label class="input-main-label block mt-0 mb-1">Data Collector</label>
              <mat-form-field
                class="select-classic w-full"
                appearance="outline"
              >
                <mat-select
                  formControlName="dcUid"
                  panelClass="single-select-overlay"
                  placeholder="Select Data Collector"
                >
                  <mat-option [value]="null">Unset</mat-option>
                  @for (dc of availableDCDevices(); track dc.id) {
                    <mat-option [value]="dc.id">{{ dc.deviceName }}</mat-option>
                  }
                </mat-select>
                <mat-icon
                  class="arrow-down"
                  fontIcon="keyboard_arrow_down"
                  matSuffix
                />
              </mat-form-field>
            </div>
          </div>
        }
      }
    </div>
  }
}
